export function init($name = '') {
    const panoramas = $($name);

    if (!panoramas.length) {
        return;
    }

    panoramas.each(function () {
        $(this).paver();
    });
}
